import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // <---


import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './assets/css/fontello.css';
import './assets/css/responsive.css';
import './assets/css/dashboard.css';
import './assets/css/style.css';

import './assets/font/demo-files/demo.css';

const app = createApp(App).use(router);

app.directive('scroll', {
    mounted(el, binding) {
        let f = function(evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener('scroll', f);
          }
        };
        window.addEventListener('scroll', f);
      },
  });

// Initialize app after ensuring no service workers or caches trigger platform prompts
// async function initApp() {
//   try {
//     if ('serviceWorker' in navigator) {
//       const regs = await navigator.serviceWorker.getRegistrations();
//       await Promise.all(regs.map(r => r.unregister()));
//       console.info('Service workers unregistered to avoid automatic permission prompts.');
//     }

//     if ('caches' in window) {
//       const keys = await caches.keys();
//       await Promise.all(keys.map(k => caches.delete(k)));
//       console.info('Caches cleared to avoid stale PWA behavior.');
//     }
//   } catch (err) {
//     console.warn('Error while unregistering service workers or clearing caches:', err);
//   }

//   app.mount('#app');
// }

// initApp();

app.mount('#app');

export default app;